import { css } from '@emotion/react';

import { toCssVariables } from './CSSVariables.utils';

export const getCssVariables = () => css`
  --color-black: #180924;
  --color-white: #fff;
  --color-primary-light: #d3caf1;
  --color-primary-dark: #462170;
  --color-information-light: #fafafd;
  --color-information-dark: #7466a8;
  --color-special-purple: #d7d3e8;
  --color-special-blue: #cbe9fa;
  --color-special-green: #bde8d9;
  --color-primary-pop: #8b53ef;
  --color-primary-pop-hover: #6c24ea;

  --color-accent-yellow: #ffe571;
  --color-accent-red: #ff7569;
  --color-accent-green: #206f6f;

  --color-neutral-0: #fdfdfc;
  --color-neutral-10: #f7f7f7;
  --color-neutral-20: #f0f0f0;
  --color-neutral-30: #e4e4e4;
  --color-neutral-40: #cfcfcf;
  --color-neutral-50: #838383;
  --color-neutral-60: #6a6a6a;
  --color-neutral-70: #2e2e2e;

  --color-success-light: #ecfdf3;
  --color-success-dark: #027a48;

  --color-warning-light: #fff0c7;
  --color-warning-dark: #fdb022;

  --color-status-error-light: #fef3f2;
  --color-status-error-dark: #c72014;

  --coco-sharp-bold-weight: 600;
  --coco-sharp-variation-settings: 'opsz' 703;

  --font-family-primary-light: 'Cocogoose Pro Light', sans-serif;
  --font-family-primary-semilight: 'Cocogoose Pro Semilight', sans-serif;
  --font-family-primary-bold: 'Cocogoose Pro Darkmode', sans-serif;
  --font-family-coco-sharp: 'Coco Sharp', sans-serif;
  --font-family-coco-sharp-italic: 'Coco Sharp Italic', sans-serif;
  --font-family-cocogoose: 'Cocogoose Pro Light', sans-serif;
  --font-family-cocogoose-bold: 'Cocogoose Pro Darkmode', sans-serif;
  --font-family-fallback: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto,
    'Helvetica Neue', Arial, sans-serif;
  --line-height-12: calc(0.75rem * var(--sembo-rem-scale, 1));
  --line-height-14: calc(0.875rem * var(--sembo-rem-scale, 1));
  --line-height-16: calc(1rem * var(--sembo-rem-scale, 1));
  --line-height-18: calc(1.125rem * var(--sembo-rem-scale, 1));
  --line-height-20: calc(1.25rem * var(--sembo-rem-scale, 1));
  --line-height-22: calc(1.375rem * var(--sembo-rem-scale, 1));
  --line-height-24: calc(1.5rem * var(--sembo-rem-scale, 1));
  --line-height-26: calc(1.625rem * var(--sembo-rem-scale, 1));
  --line-height-28: calc(1.75rem * var(--sembo-rem-scale, 1));
  --line-height-30: calc(1.875rem * var(--sembo-rem-scale, 1));
  --line-height-32: calc(2rem * var(--sembo-rem-scale, 1));
  --line-height-36: calc(2.25rem * var(--sembo-rem-scale, 1));
  --line-height-38: calc(2.375rem * var(--sembo-rem-scale, 1));
  --line-height-52: calc(3.25rem * var(--sembo-rem-scale, 1));
  --font-size-12: calc(0.75rem * var(--sembo-rem-scale, 1));
  --font-size-14: calc(0.875rem * var(--sembo-rem-scale, 1));
  --font-size-16: calc(1rem * var(--sembo-rem-scale, 1));
  --font-size-18: calc(1.125rem * var(--sembo-rem-scale, 1));
  --font-size-20: calc(1.25rem * var(--sembo-rem-scale, 1));
  --font-size-22: calc(1.375rem * var(--sembo-rem-scale, 1));
  --font-size-24: calc(1.5rem * var(--sembo-rem-scale, 1));
  --font-size-28: calc(1.75rem * var(--sembo-rem-scale, 1));
  --font-size-32: calc(2rem * var(--sembo-rem-scale, 1));
  --font-size-42: calc(2.625rem * var(--sembo-rem-scale, 1));
  --font-size-44: calc(2.75rem * var(--sembo-rem-scale, 1));
  --font-size-52: calc(3.25rem * var(--sembo-rem-scale, 1));
  --spacing-2: calc(0.125rem * var(--sembo-rem-scale, 1));
  --spacing-4: calc(0.25rem * var(--sembo-rem-scale, 1));
  --spacing-6: calc(0.375rem * var(--sembo-rem-scale, 1));
  --spacing-8: calc(0.5rem * var(--sembo-rem-scale, 1));
  --spacing-10: calc(0.625rem * var(--sembo-rem-scale, 1));
  --spacing-12: calc(0.75rem * var(--sembo-rem-scale, 1));
  --spacing-16: calc(1rem * var(--sembo-rem-scale, 1));
  --spacing-18: calc(1.115rem * var(--sembo-rem-scale, 1));
  --spacing-20: calc(1.25rem * var(--sembo-rem-scale, 1));
  --spacing-24: calc(1.5rem * var(--sembo-rem-scale, 1));
  --spacing-28: calc(1.75rem * var(--sembo-rem-scale, 1));
  --spacing-32: calc(2rem * var(--sembo-rem-scale, 1));
  --spacing-40: calc(2.5rem * var(--sembo-rem-scale, 1));
  --spacing-44: calc(2.75rem * var(--sembo-rem-scale, 1));
  --spacing-48: calc(3rem * var(--sembo-rem-scale, 1));
  --spacing-64: calc(4rem * var(--sembo-rem-scale, 1));
  --spacing-72: calc(4.5rem * var(--sembo-rem-scale, 1));
  --spacing-80: calc(5rem * var(--sembo-rem-scale, 1));
  --spacing-96: calc(6rem * var(--sembo-rem-scale, 1));
  --spacing-128: calc(8rem * var(--sembo-rem-scale, 1));
  --spacing-160: calc(10rem * var(--sembo-rem-scale, 1));
  --letter-spacing: -0.16%;
  --icon-size-s: var(--spacing-16);
  --icon-size-m: var(--spacing-24);
  --icon-size-l: var(--spacing-32);
  --mask-fade-size: var(--spacing-24);
  --font-weight-bold: 400;

  --font-body-xl: var(--font-size-18) / 150% var(--font-family-coco-sharp);
  --font-body-xl-italic: var(--font-size-18) / 150%
    var(--font-family-coco-sharp-italic);
  --font-body-xl-bold: var(--coco-sharp-bold-weight) var(--font-size-18) / 150%
    var(--font-family-coco-sharp);
  --font-body-xl-bold-italic: var(--coco-sharp-bold-weight)
    var(--font-size-18) / 150% var(--font-family-coco-sharp-italic);
  --font-body-lg: var(--font-size-16) / 150% var(--font-family-coco-sharp);
  --font-body-lg-italic: var(--font-size-16) / 150%
    var(--font-family-coco-sharp-italic);
  --font-body-lg-bold: var(--coco-sharp-bold-weight) var(--font-size-16) / 150%
    var(--font-family-coco-sharp);
  --font-body-lg-bold-italic: var(--coco-sharp-bold-weight)
    var(--font-size-16) / 150% var(--font-family-coco-sharp-italic);
  --font-body-md: var(--font-size-14) / 150% var(--font-family-coco-sharp);
  --font-body-md-italic: var(--font-size-14) / 150%
    var(--font-family-coco-sharp-italic);
  --font-body-md-bold: var(--coco-sharp-bold-weight) var(--font-size-14) / 150%
    var(--font-family-coco-sharp);
  --font-body-md-bold-italic: var(--coco-sharp-bold-weight)
    var(--font-size-14) / 150% var(--font-family-coco-sharp-italic);
  --font-body-sm: var(--font-size-12) / 150% var(--font-family-coco-sharp);
  --font-body-sm-italic: var(--font-size-12) / 150%
    var(--font-family-coco-sharp-italic);
  --font-body-sm-bold: var(--coco-sharp-bold-weight) var(--font-size-12) / 150%
    var(--font-family-coco-sharp);
  --font-body-sm-bold-italic: var(--coco-sharp-bold-weight)
    var(--font-size-12) / 150% var(--font-family-coco-sharp-italic);

  --font-label-xl: var(--font-size-18) / 125% var(--font-family-coco-sharp);
  --font-label-xl-bold: var(--coco-sharp-bold-weight) var(--font-size-18) / 125%
    var(--font-family-coco-sharp);
  --font-label-lg: var(--font-size-16) / 125% var(--font-family-coco-sharp);
  --font-label-lg-bold: var(--coco-sharp-bold-weight) var(--font-size-16) / 125%
    var(--font-family-coco-sharp);
  --font-label-md: var(--font-size-14) / 125% var(--font-family-coco-sharp);
  --font-label-md-bold: var(--coco-sharp-bold-weight) var(--font-size-14) / 125%
    var(--font-family-coco-sharp);
  --font-label-sm: var(--font-size-12) / 125% var(--font-family-coco-sharp);
  --font-label-sm-bold: var(--coco-sharp-bold-weight) var(--font-size-12) / 125%
    var(--font-family-coco-sharp);

  // CocoGoose Pro DarkMode
  --font-heading-1: var(--font-size-44) / 125% var(--font-family-cocogoose-bold);
  --font-heading-2: var(--font-size-32) / 125% var(--font-family-cocogoose-bold);
  --font-heading-3: var(--font-size-28) / 125% var(--font-family-cocogoose-bold);
  --font-heading-4: var(--font-size-24) / 125% var(--font-family-cocogoose-bold);
  --font-heading-5: var(--font-size-20) / 125% var(--font-family-cocogoose-bold);
  --font-heading-6: var(--font-size-16) / 125% var(--font-family-cocogoose-bold);

  --font-button-lg: var(--font-size-16) / 100% var(--font-family-cocogoose-bold);
  --font-button-md: var(--font-size-14) / 100% var(--font-family-cocogoose-bold);
  --font-button-sm: var(--font-size-12) / 100% var(--font-family-cocogoose-bold);

  --font-body-lg-bold-goose: var(--font-size-16) / 125%
    var(--font-family-cocogoose-bold);
  --font-body-md-bold-goose: var(--font-size-14) / 125%
    var(--font-family-cocogoose-bold);

  --border-radius-s: 0.25rem;
  --border-radius-m: 0.5rem;
  --border-radius-l: 0.75rem;
  --border-radius-xl: 1rem;
  --border-radius-xxl: 2rem;
  --elevation-10: 0px 0px 0px 1px rgba(32, 47, 71, 0.03),
    0px 0px 4px 0px rgba(32, 47, 71, 0.05),
    0px 2px 2px 0px rgba(32, 47, 71, 0.1);
  --elevation-20: 0px 0px 0px 1px rgba(32, 47, 71, 0.03),
    0px -3px 3px -2px rgba(32, 47, 71, 0.04),
    0px 2px 7px 0px rgba(32, 47, 71, 0.06),
    0px 3px 4px -1px rgba(32, 47, 71, 0.08);
  --elevation-30: 0px 0px 0px 1px rgba(32, 47, 71, 0.03),
    0px -4px 8px -2px rgba(32, 47, 71, 0.04),
    0px 3px 6px 0px rgba(32, 47, 71, 0.06),
    -10px 4px 7px -8px rgba(32, 47, 71, 0.08),
    10px 4px 7px -8px rgba(32, 47, 71, 0.08),
    0px 13px 7px -7px rgba(32, 47, 71, 0.06);

  --sidemenu-width: 320px;

  ${getThemableCssVariables()}
`;
/**
 * @description CSS properties for themable elements, following a specific naming convention.
 * @example
 * [system = sembo]
 * [domain = inspire]
 * [type = s(emantic)|p(rimitive)|c(omponent)]
 * [category = color|typography|etc.]
 * [property = background|text|border|etc.]
 * [variant = primary|secondary|tertiary|quaternary|etc.]
 * [modifier? = interactive|subtle]
 * [state? = active|hover|focus|disabled]
 * w-s-color-background-primary-subtle-active
 */
export const themableCSSProperties = {
  /**
   * @description Background color of the site.
   */
  semboInspireSColorBackgroundPrimary: 'var(--color-neutral-0)',

  /**
   * @description Background color of things like creator banner.
   */
  semboInspireSColorBackgroundSecondary: 'var(--color-white)',

  /**
   * @description Background of interactive elements.
   */
  semboInspireSColorBackgroundSecondaryInteractive: 'var(--color-neutral-0)',

  /**
   * @description Background of interactive elements.
   */
  semboInspireSColorBackgroundPrimaryInteractive: 'var(--color-black)',

  /**
   * @description Hover on the primary background.
   */
  semboInspireSColorBackgroundPrimaryInteractiveHover:
    'var(--color-neutral-70)',

  /**
   * @description Colors for texts in interactive elements
   */
  semboInspireSColorTextPrimaryInteractive: 'var(--color-white)',

  /**
   * @description Background color of the site.
   */
  semboInspireSColorBackgroundImportant: 'var(--color-information-dark)',

  /**
   * @description Background color of the site.
   */
  semboInspireSColorBackgroundImportantInteractive: 'var(--color-primary-pop)',

  /**
   * @description Background color of the site.
   */
  semboInspireSColorBackgroundImportantInteractiveHover:
    'var(--color-primary-pop-hover)',

  /**
   * @description Background of subtle elements.
   */
  semboInspireSColorBackgroundPrimarySubtle: 'transparent',

  /**
   * @description Colors for texts in interactive elements
   */
  semboInspireSColorTextPrimarySubtle: 'var(--color-black)',
} as const;

/** Why do we have a separate fn for themable?
 * Because we don't want to re-skin using old variables
 * In that case, we should try to create new, more scalable variables.
 */
export const getThemableCssVariables = () => css`
  ${toCssVariables(themableCSSProperties)};
`;

export const getFontFaces = () => css`
  @font-face {
    font-family: 'Coco Sharp Italic';
    src:
      url('https://cdn.sanity.io/files/inntox6v/production/5ca3dbfee28abe3f9928bedf78b43293918f45a7.woff2/Coco-Sharp-Variable-Italic.woff2')
        format('woff2'),
      url('https://cdn.sanity.io/files/inntox6v/production/0dfb0a3d1fe09b35d9c9ade93c6db2abb5a91a0b.woff/Coco-Sharp-Variable-Italic.woff')
        format('woff');
    font-weight: 100 900;
    font-style: italic;
    font-display: swap;
  }

  @font-face {
    font-family: 'Coco Sharp';
    src:
      url('https://cdn.sanity.io/files/inntox6v/production/9d0bb6eacd49521af3fbd01414cf2dd2bcd3000f.woff2/Coco-Sharp-Variable-Roman.woff2')
        format('woff2'),
      url('https://cdn.sanity.io/files/inntox6v/production/341124a4c61109fd1b597517b545c29cfa38808c.woff/Coco-Sharp-Variable-Roman.woff')
        format('woff');
    font-weight: 100 900;
    font-style: normal;
    font-display: swap;
  }

  @font-face {
    font-family: 'Cocogoose Pro Darkmode';
    src:
      url('https://cdn.sanity.io/files/inntox6v/production/cb0acd973f40aa4e72252f6e16cf1a6c6b9ee82b.woff2/CocogoosePro-Darkmode.woff2')
        format('woff2'),
      url('https://cdn.sanity.io/files/inntox6v/production/ad8f81bae1e42af558a7b1e49fa5e7579dad8db1.woff/CocogoosePro-Darkmode.woff')
        format('woff'),
      url('https://cdn.sanity.io/files/inntox6v/production/bdc647dbedd727ad2ca8c267e51d355949e79392.svg/CocogoosePro-Darkmode.svg')
        format('svg');
    font-weight: normal;
    font-style: normal;
    font-display: swap;
  }

  @font-face {
    font-family: 'Cocogoose Pro Semilight';
    src:
      url('https://cdn.sanity.io/files/inntox6v/production/0fd426dd95f586f6fa51b810d9c4ca060d88f834.woff2/CocogoosePro-Semilight.woff2')
        format('woff2'),
      url('https://cdn.sanity.io/files/inntox6v/production/0303fab577cc7c8f971f9fd31839d940fa01f0a2.woff/CocogoosePro-Semilight.woff')
        format('woff'),
      url('https://cdn.sanity.io/files/inntox6v/production/522d4793d87cb2090f19ffeeef2b476df25c8466.svg/CocogoosePro-Semilight.svg')
        format('svg');
    font-weight: 300;
    font-style: normal;
    font-display: swap;
  }

  @font-face {
    font-family: 'Cocogoose Pro Light';
    src:
      url('https://cdn.sanity.io/files/inntox6v/production/f8a2e25e3698e50e3590f79ab0eaf8dddd28bbf7.woff2/CocogoosePro-Light.woff2')
        format('woff2'),
      url('https://cdn.sanity.io/files/inntox6v/production/251d15dbecae5edb1cf8b985c34d88ddaa0aa5e0.woff/CocogoosePro-Light.woff')
        format('woff'),
      url('https://cdn.sanity.io/files/inntox6v/production/537d48520a7e903511c43223d9e2aae0b0e994d6.svg/CocogoosePro-Light.svg')
        format('svg');
    font-weight: 300;
    font-style: normal;
    font-display: swap;
  }
`;
